import moment from "moment";
// Constants - Functions
import { getAge } from "../../../../../../config/functions";
// Components
import { MainDiv, ColumnDiv, InformationDiv, InformationTitle, InputDiv, InputLabel, InputField, InputValue } from "./styles";
import ClinicalScores from "../clinicalScores";

const PatientInfo = ({
  patientData,
  clinicalScores,
  isLoadingClinicalScores,
  currentClinicalScore,
  setCurrentClinicalScore,
  showEditClinicalScore,
  setShowEditClinicalScore,
  refreshClinicalScores,
  setRefreshClinicalScores,
}) => {
  const renderInput = (label, value) => {
    return (
      <InputDiv>
        <InputLabel>{label}</InputLabel>
        <InputField>
          <InputValue>{value}</InputValue>
        </InputField>
      </InputDiv>
    );
  };

  return (
    <MainDiv>
      <ColumnDiv>
        <InformationDiv>
          <InformationTitle>Clinical information</InformationTitle>
          {renderInput("Patient ID", patientData.PATIENT_USER)}
          {renderInput("Date of stroke", patientData.STROKE_DATE)}
          {renderInput("AISN Group", patientData.aisnData.AISN_GROUP)}
          {renderInput(
            patientData.aisnData.AISN_GROUP === "Control" ? "Starting date" : "RGS+ Starting date",
            patientData.aisnData.ROUTINE_STARTING_DATE,
          )}
          {renderInput("Stroke side", patientData.aisnData.STROKE_SIDE)}
          {renderInput("Stroke type", patientData.aisnData.STROKE_TYPE)}
          {renderInput("Stroke location", patientData.aisnData.STROKE_LOCATION)}
          {renderInput("Comorbidity", patientData.aisnData.COMORBIDITY)}
        </InformationDiv>
        <InformationDiv>
          <InformationTitle>Demographics</InformationTitle>
          {renderInput("Gender", patientData.GENDER === "MALE" ? "Male" : "Female")}
          {renderInput("Age", getAge(moment(patientData.BIRTH_DATE, "DD/MM/YYYY").format("YYYY-MM-DD")))}
          {renderInput("Civil Status", patientData.aisnData.CIVIL_STATUS)}
          {renderInput("Home support", Boolean(patientData.aisnData.HOME_SUPPORT) ? "Yes" : "No")}
          {renderInput("Education", patientData.aisnData.EDUCATION)}
          {renderInput("Work", patientData.aisnData.WORK)}
        </InformationDiv>
      </ColumnDiv>
      <ColumnDiv>
        <ClinicalScores
          patientData={patientData}
          clinicalScores={clinicalScores}
          isLoadingClinicalScores={isLoadingClinicalScores}
          currentClinicalScore={currentClinicalScore}
          setCurrentClinicalScore={setCurrentClinicalScore}
          showEditClinicalScore={showEditClinicalScore}
          setShowEditClinicalScore={setShowEditClinicalScore}
          refreshClinicalScores={refreshClinicalScores}
          setRefreshClinicalScores={setRefreshClinicalScores}
        />
      </ColumnDiv>
    </MainDiv>
  );
};

export default PatientInfo;
